import { createScale } from '../internal';
export const spo2Scale2OxygenBounds = [{
  lower: 0,
  upper: 83,
  score: {
    type: 'low',
    value: 3
  }
}, {
  lower: 84,
  upper: 85,
  score: {
    type: 'low',
    value: 2
  }
}, {
  lower: 86,
  upper: 87,
  score: {
    type: 'low',
    value: 1
  }
}, {
  lower: 88,
  upper: 92,
  score: {
    type: 'normal',
    value: 0
  }
}, {
  lower: 93,
  upper: 94,
  score: {
    type: 'high',
    value: 1
  }
}, {
  lower: 95,
  upper: 96,
  score: {
    type: 'high',
    value: 2
  }
}, {
  lower: 97,
  upper: 100,
  score: {
    type: 'high',
    value: 3
  }
}];
/**
 * SpO2 (%) Scale 2/Oxygen `integer`
 */

export const spo2Scale2Oxygen = createScale(spo2Scale2OxygenBounds, 0);
//# sourceMappingURL=spo2-scale-2-oxygen.js.map